import { useState } from "react";
import { LoadingCircleProps, LoadingPopup } from "../loading-popup";

export const useLoading = (props: Omit<LoadingCircleProps, 'label'>) => {
  const { dotSize = '0.5rem', lap = 0.8 } = props;
  const [message, setMessage] = useState('');
  const Component = (_props?: { forceMessage?: string }) => {
    if (message || _props?.forceMessage) return (
      <LoadingPopup
        {...props}
        label={_props?.forceMessage || message}
      />
    )
    return <></>;
  }
  return {
    setLoadingMessage: setMessage,
    LoadingPopup: Component,
  }
}